// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"678":"106a6310e802997eb575","942":"8bb89b58265a1a797ea9"}[chunkId] + ".chunk.js";
};